import {
  FETCH_INITIAL_DATA_FOR_MODAL,
  FETCH_INITIAL_DATA_FOR_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_MODAL_FAILURE,
  REFRESH_OBLIGATIONS,
  REFRESH_OBLIGATIONS_SUCCESS,
  REFRESH_OBLIGATIONS_FAILURE,
} from './types';

import initialState from './initialState';

function companyCodes(state = initialState, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_FOR_MODAL:
      return {
        ...state,
        fetchingDataForModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_MODAL_SUCCESS:
      return {
        ...state,
        enabledFlagValues: action.enabledFlagValues,
        yesNoOptionalValues: action.yesNoOptionalValues,
        legalEntities: action.legalEntities,
        businessUnits: action.businessUnits,
        countryCodes: action.countries,
        businessCodes: action.businessCodes,
        chartNames: action.chartNames,
        connectionNames: action.connectionNames,
        currencyCodes: action.currencyCodes,
        usShareholderFlagValues: action.usShareholderFlagValues,
        lineOfBusinessValues: action.lineOfBusinessValues,
        homeOfficeCompanyCodeOptions: action.homeOfficeCompanyCodeOptions,
        sourceOptions: action.sourceOptions,
        fetchingDataForModal: false,
        companyCodesOptionsToValidate: action.companyCodesOptionsToValidate,
      };
    case FETCH_INITIAL_DATA_FOR_MODAL_FAILURE:
      return {
        ...state,
        fetchingDataForModal: false,
      };
    case REFRESH_OBLIGATIONS:
      return {
        ...state,
        isRefreshingObligations: true,
      };
    case REFRESH_OBLIGATIONS_SUCCESS:
    case REFRESH_OBLIGATIONS_FAILURE:
      return {
        ...state,
        isRefreshingObligations: false,
      };
    default:
      return state;
  }
}

export default companyCodes;
